

import { types } from "mobx-state-tree";
export const StyleModel = types.model("Style", {width: types.string});
export const FieldModel = types.model("FieldModel", {
  key: types.string,
  label: types.string,
  _style: types.maybeNull(StyleModel),
})
